/* eslint-disable no-empty */
import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './g33.css';
import { ProgramProvider, useProgram } from './ProgramContext';
import PasswordGate from './PasswordGate';
import { TopBar, SideRail } from './Shell';
import { ProgramLanding, DayOverview } from './Pages';
import { ModulePage } from './ModulePage';
import AdminImages from './AdminImages';

const Inner = () => {
  const { authed, checking } = useProgram();

  // Block search engines on this entire program area
  useEffect(() => {
    const tag = document.createElement('meta');
    tag.name = 'robots';
    tag.content = 'noindex, nofollow';
    document.head.appendChild(tag);
    // Load Playfair + Inter from Google Fonts
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,600&display=swap';
    document.head.appendChild(link);
    return () => {
      try { document.head.removeChild(tag); } catch {}
      try { document.head.removeChild(link); } catch {}
    };
  }, []);

  if (checking) {
    return (
      <div className="g33-program" style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div className="g33-eyebrow">Loading…</div>
      </div>
    );
  }

  if (!authed) return <PasswordGate />;

  return (
    <div className="g33-program" data-testid="gate33-program">
      <TopBar />
      <SideRail />

      <Routes>
        <Route index element={<ProgramLanding />} />
        <Route path="day/:day" element={<DayOverview />} />
        <Route path="module/:slug" element={<ModulePage />} />
        <Route path="admin/images" element={<AdminImages />} />
        <Route path="*" element={<Navigate to="/gate33-program" replace />} />
      </Routes>

      <footer style={{
        borderTop: '1px solid var(--g33-ligne)', padding: '32px 16px',
        textAlign: 'center', background: 'var(--g33-cream)',
      }}>
        <p className="g33-eyebrow" style={{ color: 'var(--g33-grey-warm)' }}>
          Gate 33 — Operational training for private aviation cabin attendant
        </p>
      </footer>
    </div>
  );
};

const Gate33Program = () => (
  <ProgramProvider>
    <Inner />
  </ProgramProvider>
);

export default Gate33Program;
